<template>
   <v-dialog v-model="open" max-width="500" persistent>
      <div class="admin-panel__dashboard__dialog">
         <p class="admin-panel__dashboard__dialog__title">
            {{ titleText }}
         </p>
         <v-form
            class="admin-panel__dashboard__dialog__body"
            v-model="isFormValid"
            @keydown.native.enter="action"
            @submit.prevent="action"
         >
            <template v-for="(item, key) in data.schema">
               <v-text-field
                  class="admin-panel__dashboard__dialog__body__item"
                  :key="key"
                  v-if="
                     key != 'user_name' &&
                     key != 'discount' &&
                     key != 'email' &&
                     key != 'password' &&
                     key != 'phone' &&
                     key != 'questions' &&
                     key != '_id' &&
                     key != 'one_month' &&
                     key != 'two_month' &&
                     key != 'trial' &&
                     key != 'createdAt' &&
                     key != 'updatedAt' &&
                     key != 'time' &&
                     key != 'type'
                  "
                  v-model.trim="data.schema[key]"
                  :label="key[0].toUpperCase() + key.slice(1)"
               ></v-text-field>
            </template>

            <!-- SUBSCRIPTION TIME FIELDS -->
            <v-text-field
               :rules="[rules.time]"
               v-model="subscribtionTime"
               class="admin-panel__dashboard__dialog__body__item"
               type="number"
               v-if="data.schema.time !== undefined"
               label="Time"
            ></v-text-field>

            <v-select
               :rules="[rules.required]"
               v-if="data.schema.time !== undefined"
               v-model="subscribtionTimePeriod"
               class="admin-panel__dashboard__dialog__body__item"
               :items="['Minutes', 'Hours', 'Days', 'Weeks', 'Months', 'Years']"
               item-text="state"
               item-value="abbr"
               label="Time Period"
            ></v-select>

            <v-text-field
               class="admin-panel__dashboard__dialog__body__item"
               v-if="data.schema.trial !== undefined"
               v-model.trim="data.schema.trial"
               label="Trial price"
            ></v-text-field>
            <v-text-field
               class="admin-panel__dashboard__dialog__body__item"
               v-if="data.schema.one_month !== undefined"
               v-model.trim="data.schema.one_month"
               label="One month price"
            ></v-text-field>
            <v-text-field
               class="admin-panel__dashboard__dialog__body__item"
               v-if="data.schema.two_month !== undefined"
               v-model.trim="data.schema.two_month"
               label="Two month price"
            ></v-text-field>
            <v-text-field
               class="admin-panel__dashboard__dialog__body__item"
               v-if="data.schema.discount !== undefined"
               v-model.trim="data.schema.discount"
               :rules="[rules.discount]"
               label="Discount"
            ></v-text-field>
            <v-text-field
               class="admin-panel__dashboard__dialog__body__item"
               v-if="data.schema.user_name !== undefined"
               v-model.trim="data.schema.user_name"
               :rules="[rules.required]"
               label="User Name"
            ></v-text-field>
            <v-text-field
               class="admin-panel__dashboard__dialog__body__item"
               v-if="data.schema.email !== undefined"
               v-model.trim="data.schema.email"
               label="E-mail"
               hint="Email@gmail.com"
            ></v-text-field>
            <v-text-field
               class="admin-panel__dashboard__dialog__body__item"
               v-if="data.schema.phone !== undefined"
               v-model.trim="data.schema.phone"
               hint="+1 415 555 0132"
               label="Phone"
            ></v-text-field>
            <v-text-field
               class="admin-panel__dashboard__dialog__body__item"
               v-if="data.schema.password !== undefined"
               v-model.trim="data.schema.password"
               :append-icon="showPassword ? 'mdi-eye' : 'mdi-eye-off'"
               :rules="[rules.required, rules.min]"
               :type="showPassword ? 'text' : 'password'"
               hint="At least 8 characters"
               label="Password"
               @click:append="showPassword = !showPassword"
            ></v-text-field>
         </v-form>
         <div class="admin-panel__dashboard__dialog__footer">
            <v-btn class="admin-panel__dashboard__dialog__footer-btn" @click="open = false"> CANCEL </v-btn>
            <v-btn class="admin-panel__dashboard__dialog__footer-btn" :disabled="!isFormValid" @click="action">
               Save
            </v-btn>
         </div>
      </div>
   </v-dialog>
</template>

<script>
export default {
   name: 'AdminPanelDashboardDialog',
   data() {
      return {
         open: false,
         showPassword: false,
         rules: {
            required: value => value.length > 0 || 'Field is requiered',
            min: value => value.length >= 8 || 'Min 8 characters',
            emailMatch: value => !!value.match(/.*@\w+\.\w{1,3}/g) || 'Email is not valid',
            phoneMatch: value => value.match(/^[0-9 ()+-]{4,16}$/) || 'Phone is not valid',
            discount: value => this.validateDiscount(value) || 'Discount must be in this range 0 - 100',
            time: value => value > 0 || 'Must be positive value and more then 0',
         },
         data: {
            name: '',
            schema: {},
            labels: {},
         },

         isFormValid: false,

         subscribtionTimePeriod: '',

         subscribtionTime: 0,
      };
   },
   computed: {
      routeName() {
         return this.$route.params.name;
      },

      isRoutNamePlural() {
         return this.routeName[this.routeName.length - 1] === 's';
      },

      isRouterGeneral() {
         return this.routeName === 'generals';
      },

      titleText() {
         if (this.isRouterGeneral) {
            return Object.keys(this.data.schema).includes('discount') ? 'Edit Discount' : 'EDIT SUBSCRIPTION';
         }
         return this.isRoutNamePlural
            ? `Edit ${this.routeName.slice(0, this.routeName.length - 1)}`.toUpperCase()
            : `Edit ${this.routeName}`.toUpperCase();
      },

      currentRoute() {
         return this.$route.params.name.toLowerCase();
      },
   },

   methods: {
      dialogOpen(data) {
         this.open = true;
         this.$nextTick(() => {
            this.data = data;
            if (this.currentRoute === 'subscribtion') {
               this.subscribtionTime = +this.data.schema.time.match(/\d+/g)[0];
            }
         });
      },

      validateDiscount(data) {
         let value = data.toString();
         return (
            value.match(/\b([0-9]|[1-9][0-9]|100)\b/) &&
            !value.match(/[-!$%^&*()_+|~=`{}:";'<>?,./@\\#]/) &&
            !value.match(/[A-Za-zА-Яа-яЁё]/)
         );
      },

      async action() {
         if (!this.isFormValid) return;
         let postValue = this.data.schema;

         if (this.currentRoute === 'subscribtion') {
            const timePeriod =
               this.subscribtionTimePeriod === 'Minutes'
                  ? 'm'
                  : this.subscribtionTimePeriod === 'Hours'
                  ? 'h'
                  : this.subscribtionTimePeriod === 'Days'
                  ? 'd'
                  : this.subscribtionTimePeriod === 'Month'
                  ? 'M'
                  : this.subscribtionTimePeriod === 'Weeks'
                  ? 'w'
                  : 'Y';

            postValue.time = `${this.subscribtionTime}${timePeriod}`;
         }

         if (this.currentRoute === 'discount') {
            postValue = { discount: postValue.discount };
         }

         try {
            await this.$http.put(
               `/admin/resources/${
                  this.$route.params.name === 'subscribtion' ? 'subscription' : this.$route.params.name
               }`,
               postValue,
            );
            this.open = false;
         } catch (error) {
            if (error?.response?.message) {
               alert(error.response.message);
            }
         } finally {
            this.$store.dispatch('admin/loadResources');
         }
      },
   },
};
</script>

<style lang="scss">
.admin-panel__dashboard__dialog {
   width: 100%;
   height: auto !important;
   padding: 30px !important;
   background-color: var(--green-lighten-4) !important;
   &__title {
      font-family: 'Roboto';
      font-size: 18px;
      font-weight: 700;
      margin-bottom: 10px;
      text-transform: uppercase;
   }
   &__body {
      width: 100%;
      &__item {
         font-family: 'Roboto';
         font-size: 16px;
         font-weight: 500;
      }
   }
   &__footer {
      display: flex;
      justify-content: space-between;

      align-items: center;
      margin-top: 10px;
      &-btn {
         background-color: var(--green-lighten-2) !important;
      }
   }
}
</style>